import SalaryInfoForm from './SalaryInfoForm';

export default SalaryInfoForm;
